var _g, _g2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortOfCallPinShadow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "0.45in",
    height: "0.55in",
    viewBox: "0 0 32.4 39.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    width: 34,
    height: 41,
    transform: "translate(0.19 -1.144)",
    opacity: 0.3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAApCAYAAABQgPsBAAAACXBIWXMAAAsSAAALEgHS3X78AAADBklEQVRYR8WYz27TQBCHvzVp1AOqoiIVCZWqcCztuVR9AHgAeEs4E7iiEnpu6JEWKBxKG6KIA4pMlsPsxJv12rHTmP4ka534z3w7M96dXWOtpa6MMQnQAhLv7wmQWmsn8afKZaqABIYTYA3YdG2CQIyAC9em1IQqBXEAbaBDZngFeAjsu/YO8Bf4BhwDX4EBAjUExlWACkGMMS1gHXgEPAEOEMMrlHtkgMD0gFPgnApAURAHsYEYfw7sAttkhgtzxB0jBOAUOAI+AWfAwFqbElEOxIM4BF649h4SIt9wmSbAGPHEOdAHuoiXLmMwLf9HAPHStRvhfRWUAKvIsx0kpGvu2ntjzFUYpqkBl5jrSDjUE4tA+FKg+8j7RsB31/4Jb1S1gcdITiwDwlcLCe8usAN0XMenSmDqjY67adc9tCwIVRtJ+EPXtv2LSlV605LkdzbnlSTwxo47r/p11JV2+AAZh6Ze1/Fg013cphlvqHR62EI+jBmQ2NzRpHTE3gLWNDxqNDZSNiWNwD5eeP6H4VDRCNwGCEQicFsgOd0WiM7U0/lGQXIXGlRYzU0gXuY1DZMito5dm4KARC80qJSsihtpOZC4kxFZrdkkSKEtzZEZSpoLT6H3fZALpJQ7R8q8JhQNCzgQ98cQKXZP3fmyvaIQX4ikgD+OjBFvHLF8r0wQ4x+Bd4hH4iCBV/rAdXjzDTQGPgNvkfAPwuI5HFlzD3DzEKVIp/ruuJ67nLDWTowxAwTCX2auhg9WVApcIuHuIp2Mhjw31zjamR6wWIg0L3rAawpCoiqa9DREXaQ3l9SHyb2jaLkJBUuGIEQJYKi+1tHl5k/m5IWvwpdaa1NjjMZXNQ9Gx4oz4AR4Q0le+CrtXQTGUrwo18TsIeE4IdsBmPvlzXNzCKOT1h6yb6JLAv/reOXaaypu0kDFrSvIbdzsAc+Ap8hnPgQ+kEGUJmZMcz2icp65IiuihsAv4AHwg2wQrA0BNTziy/POFnAX+I2rMRaBgAVBYGan0SBJXGsXMdTCIMvWPzCUez2Gr9V6AAAAAElFTkSuQmCC",
    style: {
      mixBlendMode: "multiply"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.657,14.828c0,10.422-11.829,18.505-11.829,18.505S4,25.333,4,14.828a11.829,11.829,0,0,1,23.657,0Z",
    fill: "#68159a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.828,3A11.829,11.829,0,0,1,27.657,14.828c0,10.422-11.829,18.505-11.829,18.505S4,25.333,4,14.828A11.829,11.829,0,0,1,15.828,3m0-2A13.843,13.843,0,0,0,2,14.828C2,26.264,14.189,34.639,14.708,34.99l1.126.762,1.123-.767c.518-.355,12.7-8.81,12.7-20.157A13.844,13.844,0,0,0,15.828,1Z",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4,14.828c0,10,10.7,17.719,11.74,18.444V3A11.827,11.827,0,0,0,4,14.828Z",
    fill: "#bbf75a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.657,14.828A11.829,11.829,0,0,0,15.829,3c-.03,0-.059,0-.089,0V33.272l.089.061S27.657,25.25,27.657,14.828Z",
    fill: "#97db29"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.745,15.382a5,5,0,1,1-5-5A5,5,0,0,1,20.745,15.382Z",
    fill: "#435382"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortOfCallPinShadow);
export default __webpack_public_path__ + "static/media/port-of-call-pin-shadow.9b9024cfbb6ed378057284daef7f5bb9.svg";
export { ForwardRef as ReactComponent };